import React from 'react';
import Clamp from 'shiitake';
import AlertBox, { Heading } from 'components/shared/AlertBox';
import { Button, ButtonGroup, Icon } from 'ui';
import ImagePreviewCanvas from './Canvas';

const ImagePreviewModal = props => (
  <AlertBox onDismiss={props.onDismiss}>
    <Heading>
      <Clamp lines={2}>{props.image.file_name}</Clamp>
    </Heading>
    <ImagePreviewCanvas
      image={props.image}
      imageType={props.imageType}
      isCertification={props.isCertification}
    />
    {!props.readonly && (
      <div className="mt-16">
        {!!props.image.places_used.length && (
          <div>
            <div className="ff-ss c-gray-darker fz-bigger">
              {I18n.t('image_library.used_as')}
            </div>
            {props.image.places_used.map(use => (
              <div key={use.id} className="bb-gray-lighter p-12-0">
                {use.label}
              </div>
            ))}
          </div>
        )}
        <div className="d-f fd-c mt-16">
          <span className="fz-base c-gray-dark mb-16">
            <Icon name="info" className="mr-4" />
            {I18n.t('image_library.replace_warning')}
          </span>
          <ButtonGroup alignEnd>
            <Button onClick={() => props.onDelete(props.image)}>
              {I18n.t('common.delete')}
            </Button>
            <Button onClick={() => props.onReplace(props.image)}>
              {I18n.t('image_library.replace_image')}
            </Button>
          </ButtonGroup>
        </div>
      </div>
    )}
  </AlertBox>
);

ImagePreviewModal.defaultProps = {
  readonly: true,
  onDelete: () => {},
  onReplace: () => {},
};

export default ImagePreviewModal;
